export default "https://assets.egbcdn.net/assets/packs/_/images/svg_icons/app-android-f3137895aab781692c337d349573c407.svg";